import { Validator } from '@utils/validations/validation.type';

export const min: Validator = ({
  value,
  minValue,
  message,
  allowEmptyValue,
}: {
  value: string;
  minValue: number;
  message: string;
  allowEmptyValue?: boolean;
}) => {
  if (allowEmptyValue && value === '') return undefined;
  const isValid = +value >= +minValue;
  return isValid ? undefined : message;
};
